import React from "react";
import ReactDOM from "react-dom/client";
import ProductListPageTypeConfig from "../ProductListPageTypeConfig";
import PackageCategoryWatchdogModal from "./PackageCategoryWatchdogModal";

export default new class PackageCategoryWatchdogFormService {
    public init(productListPageTypeConfig: ProductListPageTypeConfig): void {
        for (const openCategoryWatchdogFormButton of document.querySelectorAll<HTMLButtonElement>(".js-open-category-watchdog-form")) {
            this.initOpenCategoryWatchdogFormButton(openCategoryWatchdogFormButton, productListPageTypeConfig);
        }
    }

    private initOpenCategoryWatchdogFormButton(openCategoryWatchdogFormButton: HTMLButtonElement, productListPageTypeConfig: ProductListPageTypeConfig): void {
        openCategoryWatchdogFormButton.addEventListener("click", () => this.openPopup(productListPageTypeConfig));
    }

    private openPopup(productListPageTypeConfig: ProductListPageTypeConfig): void {
        if (productListPageTypeConfig.packageCategoryId === undefined) {
            throw new Error("Package category ID is not defined.");
        }

        if (productListPageTypeConfig.categoryTitle === undefined) {
            throw new Error("Package category title is not defined.");
        }

        const popupContainer = document.createElement("div");
        const root = ReactDOM.createRoot(popupContainer);

        document.body.appendChild(popupContainer);

        root.render(<PackageCategoryWatchdogModal
            packageCategoryId={productListPageTypeConfig.packageCategoryId}
            packageCategoryTitle={productListPageTypeConfig.categoryTitle}
            onAfterClose={(): void => {
                root.unmount();
                popupContainer.remove();
            }}
        />);
    }
}();
